import { Box, Table, TableBody, TableCell, TableRow, Tooltip } from "@mui/material";
import { BuildItem } from "../../../api/brawler-stats/brawler-stats.types";
import { CardContainer } from "../../../components/base-components/base-componets";
import { ImageBuild, TableContainer, Title } from "./build-card.styles";
import { BuildType } from "../brawler.types";
import { useTranslation } from "react-i18next";
import { getBrawlerImgSrc, getGearSrc, ImageType } from "../../../shared/functions";
import { logEvent } from "firebase/analytics";
import { analytics } from '../../../configuration/firebase';

interface Props {
  brawlerName: string;
  buildItems: BuildItem[];
  buildType: BuildType;
}

export const BuildCard: React.FC<Props> = ({
  brawlerName,
  buildItems,
  buildType
}: Props) => {
  const { t } = useTranslation();

  const getItemImage = (buildType: BuildType, brawlerName?: string, itemName?: string): string => {
    switch (buildType) {
      case BuildType.GEARS:
        return getGearSrc(itemName);
      case BuildType.STAR_POWERS:
        return getBrawlerImgSrc(ImageType.STAR_POWER, brawlerName, itemName);
      case BuildType.GADGETS:
        return getBrawlerImgSrc(ImageType.GADGETS, brawlerName, itemName);
    }
  }

  return (
    <Box>
      <Title component="h2">
        {buildType}
      </Title>
      <CardContainer>
        <TableContainer>
          <Table size="small">
            <TableBody>
              {buildItems.map((item) => (
                <TableRow key={item.id}>
                  <TableCell sx={{ width: '1%', whiteSpace: 'nowrap' }}>
                    <ImageBuild
                      component="img"
                      alt={buildType + " " + item.name}
                      src={getItemImage(buildType, brawlerName, item.name)}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = getItemImage(buildType);
                        logEvent(analytics, 'image_error', {
                          name: brawlerName,
                        });
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ width: "50%" }}>
                    {item.name}
                  </TableCell>
                  <TableCell>
                    <Tooltip title={t("PAGES.BRAWLER.BUILD.UNLOCK_TOOLTIP")} placement="top" enterDelay={800}>
                      <Box>
                        {Math.round((item.buildStats.number / item.buildStats.total) * 100)}%
                      </Box>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContainer>
    </Box>
  );
}
